(()=>{
  const roots=()=>[...document.querySelectorAll('.jv-offers')];
  function selection(root){
    const picker=document.getElementById(`quantity-breaks-${root.dataset.section}`);
    const quantity=Number(picker?.querySelector('input[name="quantity"]:checked')?.value||1);
    const label=picker?.querySelector(`label[data-quantity="${quantity}"]`);
    const variants=JSON.parse(root.querySelector('[data-variants]').textContent);
    const rows=[...(label?.querySelectorAll('[data-selected-id]')||[])];
    const selected=rows.map(row=>variants.find(v=>String(v.id)===row.dataset.selectedId)).filter(Boolean);
    const groups={};
    selected.forEach(v=>{if(!groups[v.id])groups[v.id]={price:v.price,quantity:0};groups[v.id].quantity++;});
    if(!selected.length)groups[variants[0].id]={price:variants[0].price,quantity};
    const percent=quantity>=3?20:quantity>=2?10:0;
    const discounted=Object.values(groups).reduce((sum,line)=>{const value=line.price*line.quantity;return sum+value-Math.floor((value*percent+0.000001)/100);},0);
    const extras=[...root.querySelectorAll('[data-addon]:checked')].filter(input=>!(quantity>=3&&input.dataset.addon==='guarantee'));
    return{quantity,extras,discounted,total:discounted+extras.reduce((sum,input)=>sum+Number(input.dataset.price),0)};
  }
  function update(root){
    const selected=selection(root);
    root.querySelector('.jv-trio-gift').hidden=selected.quantity<3;
    root.querySelector('[data-guarantee-row]').hidden=selected.quantity>=3;
    const money=value=>new Intl.NumberFormat('en-US',{style:'currency',currency:root.dataset.currency||'USD'}).format(value/100);
    root.querySelector('[data-total]').textContent=money(selected.total);
    const picker=document.getElementById(`quantity-breaks-${root.dataset.section}`);
    const label=picker?.querySelector(`label[data-quantity="${selected.quantity}"]`);
    if(label){
      label.querySelector('.quantity-break__price').textContent=money(selected.discounted);
      const rows=[...label.querySelectorAll('[data-selected-id]')];
      const variants=JSON.parse(root.querySelector('[data-variants]').textContent);
      const regular=rows.reduce((sum,row)=>sum+(variants.find(v=>String(v.id)===row.dataset.selectedId)?.price||0),0);
      const caption=label.querySelector('.quantity-break__caption');
      if(caption?.dataset.text)caption.textContent=caption.dataset.text.replace('[amount_saved]',money(regular-selected.discounted));
    }
  }
  function appendToFormData(data,section){
    const root=document.getElementById(`JollyveilOffers-${section}`);
    if(!root)return;
    const chosen=selection(root);
    let indices=[...data.keys()].map(key=>key.match(/^items\[(\d+)\]\[id\]$/)?.[1]).filter(x=>x!==undefined).map(Number);
    if(!indices.length){
      data.set('items[0][id]',data.get('id'));
      data.set('items[0][quantity]',String(chosen.quantity));
      data.delete('id');data.delete('quantity');indices=[0];
    }
    const group=`jv-${Date.now()}-${Math.random().toString(36).slice(2,7)}`;
    indices.forEach(i=>data.set(`items[${i}][properties][_jv_bundle]`,group));
    let next=Math.max(...indices)+1;
    function add(id,kind){
      if(!id)return;
      const i=next++;
      data.set(`items[${i}][id]`,id);
      data.set(`items[${i}][quantity]`,'1');
      data.set(`items[${i}][properties][_jv_bundle]`,group);
      data.set(`items[${i}][properties][_jv_service]`,kind);
    }
    chosen.extras.forEach(input=>add(input.value,input.dataset.addon));
    if(chosen.quantity>=3)add(root.dataset.guaranteeId,'gift');
  }
  document.addEventListener('change',event=>{
    if(event.target.closest('.jv-offers, quantity-breaks'))requestAnimationFrame(()=>roots().forEach(update));
  });
  document.addEventListener('DOMContentLoaded',()=>roots().forEach(update));
  document.addEventListener('shopify:section:load',()=>roots().forEach(update));
  let cleanupRunning=false;
  async function cleanup(){
    if(cleanupRunning)return;
    cleanupRunning=true;
    try{
      const base=window.Shopify?.routes?.root||'/';
      const cart=await fetch(`${base}cart.js`).then(r=>r.json());
      const groups={};
      cart.items.forEach(item=>{const group=item.properties?._jv_bundle;if(group&&!item.properties?._jv_service)groups[group]=(groups[group]||0)+item.quantity;});
      const updates={};
      cart.items.forEach(item=>{const group=item.properties?._jv_bundle;const service=item.properties?._jv_service;if(group&&service&&(!groups[group]||(service==='gift'&&groups[group]<3)))updates[item.key]=0;});
      if(Object.keys(updates).length){
        const drawer=document.querySelector('cart-drawer');
        const sections=drawer?.getSectionsToRender().map(x=>x.id)||['cart-drawer','cart-icon-bubble'];
        const updated=await fetch(`${base}cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates,sections,sections_url:location.pathname})}).then(r=>r.json());
        drawer?.renderContents(updated);
      }
    }catch(error){console.error('Jollyveil cart update failed',error);}finally{cleanupRunning=false;}
  }
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,()=>setTimeout(cleanup,250));
  window.JollyveilOffers={appendToFormData};
})();
